// Lowercase, hyphen-joined, alphanumeric-only slug. Defaults to 40 chars
// max with a random fallback so callers always get a non-empty result.
export const slugify = (s, { maxLen = 40, fallbackPrefix = 'slot' } = {}) => {
  const out = String(s || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-+|-+$)/g, '')
    .slice(0, maxLen)
  if (out) return out
  return `${fallbackPrefix}-${Math.random().toString(36).slice(2, 6)}`
}
